import { useMutation } from '@tanstack/react-query';
import { queryClient } from '../app/queryClient';
import { apiRequest } from '../util/apiRequest';

const updateLessonComplete = (
   key,
   { lessonId, newCompletedValue, trackDate }
) => {
   queryClient.setQueryData(key, (oldProgress) => {
      if (newCompletedValue) {
         let completedObj = { id: lessonId };
         if (trackDate) {
            completedObj.date = new Date().toISOString();
         }
         return [...oldProgress, completedObj];
      }

      return oldProgress.filter(({ id }) => id !== lessonId);
   });
};
const useSetLessonComplete = (courseId) => {
   return useMutation({
      mutationFn: ({ lessonId, newCompletedValue, trackDate = false }) => {
         const path = `/course/lesson-completion/${courseId}/${lessonId}`;
         if (newCompletedValue) {
            return apiRequest({
               path,
               method: 'PUT',
               body: {
                  trackDate,
               },
            });
         }
         return apiRequest({
            path,
            method: 'DELETE',
         });
      },
      onMutate: async ({ lessonId, newCompletedValue, trackDate }) => {
         const key = ['courseProgress', courseId];
         await queryClient.cancelQueries({
            queryKey: key,
         });

         updateLessonComplete(key, {
            lessonId,
            newCompletedValue,
            trackDate,
         });
      },
      onError: (err, { lessonId, newCompletedValue }) => {
         updateLessonComplete(['courseProgress', courseId], {
            lessonId,
            newCompletedValue: !newCompletedValue,
         });
      },
   }).mutate;
};

export { useSetLessonComplete };
